/*
  assets/nibec-envio-banda.js · Bigbuda · T-0789 · 17-oct-2026
  Medición de la banda de envío gratis del home (snippets/nibec-envio-banda.liquid). Solo lee; no cambia nada de la página.
    nibec_envio_banda_vista  la primera vez en la sesión que la banda se ve al menos al 50 %
    nibec_envio_banda_clic   clic en el botón
  Datos: dispositivo (celular, computador) y escalera (true si la línea de apoyo habla del descuento por unidad).
  Se publica en Shopify.analytics y en dataLayer, como el resto del tema. Heatmap lee los data-hm-id del snippet.
*/
(function () {
  if (window.__nibecEnvioBanda) return;
  window.__nibecEnvioBanda = true;

  var CLAVE = 'nibec_envio_banda_vista';

  function dispositivo() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador';
  }

  function medir(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos);
    } catch (e) {}
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nombre }, datos));
    } catch (e) {}
  }

  function datosDe(el) {
    return { dispositivo: dispositivo(), escalera: el && el.getAttribute('data-escalera') === '1' };
  }

  function observar() {
    var banda = document.querySelector('[data-envio-vista]');
    if (!banda || !('IntersectionObserver' in window)) return;
    try { if (window.sessionStorage.getItem(CLAVE)) return; } catch (e) {}
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        try { window.sessionStorage.setItem(CLAVE, '1'); } catch (e) {}
        medir('nibec_envio_banda_vista', datosDe(banda));
      });
    }, { threshold: 0.5 });
    io.observe(banda);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-envio-clic]') : null;
    if (!a) return;
    medir('nibec_envio_banda_clic', datosDe(a.closest('[data-envio-vista]')));
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar);
  else observar();
})();
